import { render, staticRenderFns } from "./auth-header.vue?vue&type=template&id=c040f712&scoped=true"
import script from "./auth-header.vue?vue&type=script&lang=js"
export * from "./auth-header.vue?vue&type=script&lang=js"
import style0 from "./auth-header.vue?vue&type=style&index=0&id=c040f712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c040f712",
  null
  
)

export default component.exports